import Login from "../auth/Login";
import DiscoverMleiha from "../views/DiscoverMleiha";

let routes = [
    {
        path: '/auth/login',
        component: Login,
        layout: 'auth',
    },
    {
        path: '/pos/DiscoverMleiha',
        component: DiscoverMleiha,
        layout: 'pos',
    },

];
export default routes;